import { useLazyQuery } from "@apollo/client";
import { Badge, Grid, makeStyles, Theme } from "@material-ui/core";
import useText from "constants/text";
import { useAlertDispatch } from "contexts/AlertContext";
import { InationalTransportPoint, IProductPick, ItemAtPoint } from "contexts/RequestQuoteContext";
import { allProductsQuery } from "domains/Catalog/graphql/queries";
import { useCurrentClient } from "hooks";
import React, { useEffect, useMemo, useState } from "react";
import PickProducts from "../Catalog";
import ArticlesToDeliveryAtPoint from "./ArticlesToDeliveryAtPoint";
import { CotainerArticlePoint, SectionArticlePoint } from "./MainStyles";
import { usePickupOrDeliverStyles } from "./styles";
import { Address } from "generated/graphql";

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    display: "flex", 
    paddingTop: "6%"
  },
  badge: {
    right: "4%",
    bottom: "20%"
  },
  containerArticle: {
    [theme.breakpoints.down("xs")]: {
      paddingTop: "13px",
    },
  },
}));

interface IArticleToPick {
  articlesTopick: ItemAtPoint[];
  positionPoint: number;
  onChange: (articlesTopick: ItemAtPoint[]) => void;
  isStop?: boolean;
  articlesToDeliver?: ItemAtPoint[];
  possibleArticlesToDeliver?: IProductPick[];
  productsChecked?: ItemAtPoint[];
  onChangeDeliver?: (articlesDeliver: ItemAtPoint[]) => void;
  onChangeToPick?: (articlesTopick: ItemAtPoint[]) => void;
  point?: InationalTransportPoint;
  addressForPick?: string;
}
export default function ArticleToPickAtPoint({
  addressForPick,
  articlesToDeliver,
  possibleArticlesToDeliver,
  productsChecked,
  onChangeDeliver,
  onChangeToPick,
  point,
  articlesTopick,
  isStop,
  onChange,
  positionPoint,
}: IArticleToPick) {
  const { text } = useText();
  const [allProductsClient, { data }] = useLazyQuery(allProductsQuery);
  const [openCatalog, setOpenCatalog] = useState(false);
  const [dropIn, setDropIn] = useState(false);
  const [itemToDropIn, setItemToDropIn] = useState(0);
  const [itemToPick, setItemToPick] = useState(0);
  const [openDescribeDialog, setOpenDescribeDialog] = useState(false);
  const [changeColor,setChangeColor] = useState(false);
  const [changeColorDrop,setChangeColorDrop] = useState(false);
  const [products, setProDucts] = useState(null);
  const { client } = useCurrentClient();
  const dispatchAlert = useAlertDispatch();
  const styles = useStyles();
  const classes = usePickupOrDeliverStyles();

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    client &&
      allProductsClient({
        variables: { queries: { clientId: client?._id } },
      });
  }, [client]);

  useEffect(() => {
    if (data) {
      if (data.allProducts?.statusCode === "10000") {
        setProDucts(data.allProducts?.data?.products);
      } else {
        dispatchAlert({
          message: text.all.error_getting_data,
          severity: "error",
        });
      }
    }
  }, [data]);

  const isProductInCatalog = (product: IProductPick) =>
    products?.findIndex((p: any) => p?._id === product?._id || p?._id === product?.refPickupDelivery) !== -1;

  const onValidateFromCatalog = (currentStop: InationalTransportPoint, itemsAtPoint: ItemAtPoint[]) => {
    onChange(
      itemsAtPoint?.map(({ product, ...rest }) => ({ ...rest, product: { ...product, pickup: positionPoint } }))
    );
    setOpenCatalog(false);
  };

  const onValidateFromDescribeDialog = (product: IProductPick, count: number) => {
    const newArticleToPick = articlesTopick || [];
    const newProduct = product;
    newProduct.value = 0;
    newProduct.pickup = positionPoint;
    newArticleToPick?.push({
      product: newProduct,
      counter: count,
      remainder: count,
    });
    onChange(newArticleToPick);
    setOpenDescribeDialog(false);
  };

  const onValidateFromListDescription = (itemsAtPoint: ItemAtPoint[]) => {
    onChange(articlesTopick?.filter((o) => o?.product?._id?.length !== 13)?.concat(itemsAtPoint));
  };

  const getArticlesDescribed = () =>
    articlesTopick?.filter((o) => o?.product?._id?.length === 13 || (products && !isProductInCatalog(o?.product)));
    
  const getNumberOfProductsToPick = React.useCallback(
    () => 
      articlesTopick?.map((o) => o?.counter).reduce((a, b) => a + b, 0),
    [articlesTopick],
  );

   React.useCallback( () =>
  {
    if(dropIn){
      setItemToPick(null)
      setItemToDropIn(articlesTopick.reduce((acc,current)=>current?.counter+acc,0));
      setChangeColorDrop(true);
    }
    setItemToPick(articlesTopick.reduce((acc,curent)=>curent?.counter+acc,0));

  },
    [articlesTopick],
  );

  const checkValueOfDrop = useMemo(
    () =>  articlesToDeliver?.map((o) => o?.counter).reduce((a, b) => a + b, 0) > 0,

    [articlesToDeliver]);

  const checkValue = useMemo(
    ()=> articlesTopick?.map((o) => o?.counter).reduce((a, b) => a + b, 0) > 0,

   [articlesTopick]);

  const handleOpenToPick = () => {
    setDropIn(false);
    setOpenCatalog(true);
  }

  const handleOpenToDeliver = () => {
    setDropIn(true);
    setOpenCatalog(true);
  }

  useEffect(() => {
    if (checkValue) {
      setChangeColor(true);
    }
    else if (checkValueOfDrop){
      setChangeColorDrop(true);
    }
  }, [checkValue]);

  return (
    <>
        <Grid container direction="row"  justifyContent="space-between" className={styles.content}>
        <SectionArticlePoint customWidth={!isStop} onClick={handleOpenToPick} className={ changeColor ? classes.thereAreValues: classes.thereAreNotValue}>
        {text.all.product_to_pick}
        <Badge badgeContent={getNumberOfProductsToPick()} color="primary" className={styles.badge} />
      </SectionArticlePoint>
      

      {isStop && (
        <ArticlesToDeliveryAtPoint
            possibleArticlesToDeliver={possibleArticlesToDeliver}
            productsChecked={productsChecked}
            positionPoint={positionPoint}
            onChange={onChangeDeliver}
            articlesToDeliver={articlesToDeliver}
            point={point} productsAlreadyDelivered={[]}        />
      )}
      </Grid>
      {openCatalog && (
        <PickProducts
          open={openCatalog}
          isForDelivery={dropIn}
          onClose={() => setOpenCatalog(false)}
          articlesTopick={getArticlesDescribed()}
          onValidateProduct={onValidateFromDescribeDialog}
          onValidateFromList={onValidateFromListDescription}
          onValidateCatalogProduct={onValidateFromCatalog}
          catalogCheckedProducts={articlesTopick}
          catalogProducts={products || []}
          positionPoint={positionPoint}
          point={point}
          checkedProducts={articlesTopick}
          addressForPick={addressForPick}
        />
      )}
    </>
  );
}
